<template>
  <div>
  <el-dialog title="业绩调整" :visible.sync="dialogVisible" @close='dialogFormVisible' :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form size="small" :model="form">
      <el-form-item label="编号" :label-width="formLabelWidth">
        <div>{{form.id}} 月份：{{ form.log_time }}</div>
      </el-form-item>
      <el-form-item label="所属用户" :label-width="formLabelWidth">
        <div>{{form.user.nickName}}(用户ID：{{form.user.user_id}})</div>
      </el-form-item>
      <el-form-item label="总业绩" :label-width="formLabelWidth">
        <div>{{form.total_performance}}</div>
      </el-form-item>
      
      <el-form-item label="调整金额" :label-width="formLabelWidth">
        <el-input v-model="form.dec_money" type="number" autocomplete="off"></el-input>
        <div class="lh18 mt10 red">
          <p>注：设置后实际业绩总额=累计+调整金额</p>
        </div>
      </el-form-item>
      <el-form-item label="备注" :label-width="formLabelWidth">
        <el-input v-model="remark" type="text" autocomplete="off"></el-input>
      </el-form-item>
      
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible">取 消</el-button>
      <el-button type="primary" @click="editInfo" :loading="loading">确 定</el-button>
    </div>
  </el-dialog>
   <!--用户选择-->
  <GetUser :is_open="open_user" @close="closeUserDialog"></GetUser>
  </div>
</template>

<script>
  import UserApi from '@/api/user.js';
  export default {
    data() {
      return {
         open_user: false,
        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        loading: false,
        dialogVisible: false,
        remark:''
      };
    },
    props: ['open_edit', 'form'],
    created() {

      this.dialogVisible = this.open_edit;

    },
    methods: {

      /*修改用户*/
      editInfo() {
        let self = this;
        self.loading = true;
        let params = {
          id:self.form.id,
          dec_money:self.form.dec_money,
          remark:self.remark,
        };
        UserApi.editProfits(params, true)
          .then(data => {
            self.loading = false;
            if (data.code == 1) {
              self.$message({
                message: '用户修改成功',
                type: 'success'
              });
              self.dialogFormVisible(true);
            }
          })
          .catch(error => {
            self.loading = false;
          });
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },
      /*打开用户弹窗*/
    openUserDialog() {
      this.open_user = true;
    },
    /*关闭用户弹窗*/
    closeUserDialog(e) {
      if (e.type != 'error') {
        this.user = e.params[0];
        this.form.referee_id = e.params[0].user_id;
      }
      this.open_user = false;
    },


    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/user/user/dialog/Profitsedit.vue